export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/containers/index.ts